const USER_ROLE = {
    ROLE_ADMINISTRATOR: {
        key:"ROLE_ADMINISTRATOR",
        textValue:"Admin"
    },
    ROLE_CONTROLER: {
        key:"ROLE_CONTROLER",
        textValue:"Controler"
    },
    ROLE_GUEST: {
        key:"ROLE_GUEST",
        textValue:"Vizitator"
    },
    ROLE_OPERATIONAL: {
        key:"ROLE_OPERATIONAL",
        textValue:"Operațional"
    },
    ROLE_CLUB_MANAGER: {
        key:"ROLE_CLUB_MANAGER",
        textValue:"Club Manager"
    }
}

export default USER_ROLE;
